import { render, staticRenderFns } from "./help-send.vue?vue&type=template&id=e2d3976c&scoped=true"
import script from "./help-send.vue?vue&type=script&lang=js"
export * from "./help-send.vue?vue&type=script&lang=js"
import style0 from "./help-send.vue?vue&type=style&index=0&id=e2d3976c&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d3976c",
  null
  
)

export default component.exports